import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {ListIcon} from 'shells/icon/svg/list-icon';
import {SortIcon} from 'shells/icon/svg/sort-icon';
import {PopoverSort} from 'shells/popover/popover-sort';
import type {Direction} from 'shells/popover/popover-sort-deprecated';

import {CustomizeLeadCardsUpsell} from './customize-lead-cards-upsell';

import styles from './sort-and-customize-button.module.css';

const SORT_FIELD_OPTIONS = [
    {
        id: 'value',
        label: 'Value',
    },
    {
        id: 'closedTime',
        label: 'Close date',
    },
    {
        id: 'createdTime',
        label: 'Open date',
    },
    {
        id: 'nextActivityStartTime',
        label: 'Next activity start time',
    },
];

type Props = {
    activeSort: {
        field: string;
        direction?: Direction;
    };
    onChangeSort: (sortField: string) => any;
    onCustomizeCards?: () => void;
};

export function SortAndCustomizeButton(props: Props) {
    const requiresUpgrade = !NutClientConfig.hasCustomizableLeadCards;
    const buttonRef = React.useRef(null);
    const [isPopoverOpen, setIsPopoverOpen] = React.useState<boolean>(false);
    const [isShowingUpsell, setIsShowingUpsell] = React.useState<boolean>(false);

    return (
        <>
            <button
                ref={buttonRef}
                onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                className={styles['sort-and-customize-button']}
            >
                <SortIcon
                    size={19}
                    wrapWithDiv={false}
                    // @ts-expect-error
                    fill={colors.greyDk}
                    ascending={props.activeSort.direction === 'ascending'}
                />
                {props.onCustomizeCards ? 'Sort & customize' : 'Sort'}
            </button>
            {isPopoverOpen && (
                <PopoverSort
                    anchor={buttonRef.current}
                    activeSort={props.activeSort}
                    onChangeSort={props.onChangeSort}
                    location='bottom-left'
                    onClose={() => setIsPopoverOpen(false)}
                    fields={SORT_FIELD_OPTIONS}
                    footerRow={
                        props.onCustomizeCards
                            ? {
                                  label: 'Customize lead cards',
                                  icon: (
                                      <ListIcon
                                          size={15}
                                          fill={requiresUpgrade ? colors.greyLt : colors.blue}
                                          alignCenter={true}
                                      />
                                  ),
                                  requiresUpgrade,
                                  onClick: () => {
                                      if (requiresUpgrade) {
                                          setIsShowingUpsell(true);
                                      } else if (props.onCustomizeCards) {
                                          props.onCustomizeCards();
                                      }

                                      setIsPopoverOpen(false);
                                  },
                              }
                            : undefined
                    }
                />
            )}
            {isShowingUpsell && (
                <CustomizeLeadCardsUpsell onClose={() => setIsShowingUpsell(false)} />
            )}
        </>
    );
}
